import type { BatchPreviewTransitionPageProps } from "./batch-preview-transition-page.type";

import { useTranslation } from "react-i18next";

import { StateTag } from "@/modules/state-tag";

import { BatchPreviewPageDescription } from "../batch-preview-page-description";
import { BatchPreviewPageLayout } from "../batch-preview-page-layout";
import {
  useBatchPreviewGetUserName,
  useBatchPreviewStateParam,
} from "../batch-preview.hook";

export const BatchPreviewTransitionPage = ({
  model,
  children,
}: BatchPreviewTransitionPageProps) => {
  const { t } = useTranslation();
  const stateParam = useBatchPreviewStateParam();
  const { userName } = useBatchPreviewGetUserName();

  return (
    <BatchPreviewPageLayout
      title={t(`global:batchPreview.transition.${model}.title`)}
    >
      <BatchPreviewPageDescription
        i18nKey={`global:batchPreview.transition.${model}.description`}
        values={{ userName }}
        components={{
          StateTag: <StateTag type={model} value={stateParam} />,
        }}
      />
      {children}
    </BatchPreviewPageLayout>
  );
};
